
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionContact, ReceptionContactDetail } from "../../../../domain/workflow/reception";
import { WorkflowCommonMixin } from "../../mixins";
import ReceptionContactDetailView from "./ReceptionContactDetailView.vue";

@Component({
  components: {
    ReceptionContactDetailView,
  }
})
export default class ReceptionContactView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  contact: ReceptionContact;

  get details(): ReceptionContactDetail[] {
    return this.contact ? this.contact.details : [];
  }

  get note(): string {
    return this.contact ? this.contact.note : "";
  }

  detailClassName(index: number): string {
    return this.details.length === (index + 1)
      ? "last"
      : "";
  }
}
